function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M58.095 28.67l-1.15-6.304a2 2 0 013.104-2.005l18.761 12.94a1 1 0 010 1.647L60.037 47.896a2 2 0 01-3.104-2.001l1.212-6.725H35.5a5 5 0 00-5 5v35.5H20v-40.5c0-5.8 4.701-10.5 10.5-10.5h27.595z",
    fill: "#000",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/directions/ic-turn-right.svg";